export default (values) => {

  const errors = {}

  if (!values.type) errors.type = 'Required'

  return errors
  
}